import React, { useState } from 'react';

/**
 * Tooltip component
 * Usage:
 * <Tooltip text="Your tooltip text here"><button>Hover me</button></Tooltip>
 */
const Tooltip = ({ text, children }) => {
    const [visible, setVisible] = useState(false);

    return (
        <div className="relative inline-block"
            onMouseEnter={() => setVisible(true)}
            onMouseLeave={() => setVisible(false)}
            onFocus={() => setVisible(true)}
            onBlur={() => setVisible(false)}
            tabIndex={0}
            style={{ outline: 'none' }}
        >
            {children}
            <div
                className={`pointer-events-none absolute left-1/2 -translate-x-1/2 bottom-full mb-2 z-50 transition-opacity duration-200 ${visible ? 'opacity-100' : 'opacity-0'}`}
                style={{ minWidth: 'max-content' }}
                role="tooltip"
            >
                <div className="bg-black text-white text-xs rounded py-1 px-2 shadow-lg whitespace-nowrap">
                    {text}
                </div>
            </div>
        </div>
    );
};

export default Tooltip; 